
const digest = '526847bf554883d59f51722d9428ad35c25c1cebf3b5d55c1312a938bb0ddce4';
const classes = {"removeBtn":"_removeBtn_b874a_1","removeIcon":"_removeIcon_b874a_10"};
const css = `._removeBtn_b874a_1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

._removeIcon_b874a_10 {
  width: 14px;
  height: 14px;
  display: block;
  filter: brightness(0) saturate(100%) invert(22%) sepia(91%) saturate(5333%) hue-rotate(355deg) brightness(95%) contrast(95%);
  opacity: 0.9;
}

._removeBtn_b874a_1:hover ._removeIcon_b874a_10 {
  opacity: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  